import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./footer.scss";

const Footer = () => {
  let location = useLocation();
  const footerBg = () => {
    return (
      <>
        <div className="bg_1 bg_img">
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 1440 449"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className="line"
              d="M483.038 6.91782C276.602 -47.0315 42.3312 281.16 -49 452H1537L1558.5 390.5C1456.88 257.875 1352.3 131.863 1300.46 94.0235C1174.23 -18.8206 1030.27 106.949 974.062 183.939C910.719 272.955 836.78 235.641 807.729 205.856C667.827 71.8817 532.976 17.4079 483.038 6.91782Z"
            />
          </svg>
        </div>
        <div className="bg_2 bg_img">
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 1440 402"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className="bg"
              d="M461.485 5.36676C274.277 -43.5585 46.3249 255.57 -36.5 410.5L1459 409V371.5C1366.84 251.225 1249.79 118.676 1202.78 84.3606C1088.3 -17.9747 957.746 96.0823 906.777 165.903C849.333 246.629 782.281 212.789 755.935 185.779C629.064 64.2808 506.772 14.88 461.485 5.36676Z"
            />
          </svg>
        </div>
      </>
    );
  };
  return (
    <footer id="footer">
      <div className="container">
        <div className="row m-0">
          <div
            className="col-12 col-sm-6 col-lg-4 order-1 order-sm-2 order-lg-1"
            style={{ marginBottom: "30px" }}
          >
            <div className="one">
              <div className="brand">
                <img src="/logo.png" alt="logo" style={{ height: "50px" }} />
              </div>
              <div>
                <p>
                  21 Ezgulik Bodomzor Yunusabad district Tashkent city
                  Uzbekistan
                </p>
              </div>
            </div>
          </div>
          <div
            className="col-12 col-lg-4 d-flex justift-content-center align-items-center order-2 order-sm-1 order-lg-2"
            style={{ marginBottom: "20px" }}
          >
            <div className="footer_link">
              <div className="nav-item">
                <Link
                  to="/home"
                  className={
                    location.pathname === "/home"
                      ? "nav-link active"
                      : "nav-link"
                  }
                >
                  Home
                </Link>
              </div>
              <div className="nav-item">
                <Link
                  to="/services"
                  className={
                    location.pathname === "/services"
                      ? "nav-link active"
                      : "nav-link"
                  }
                >
                  Services
                </Link>
              </div>
              <div className="nav-item">
                <Link
                  to="/portfolio"
                  className={
                    location.pathname === "/portfolio"
                      ? "nav-link active"
                      : "nav-link"
                  }
                >
                  Portfolio
                </Link>
              </div>
              <div className="nav-item">
                <Link
                  to="/about"
                  className={
                    location.pathname === "/about"
                      ? "nav-link active"
                      : "nav-link"
                  }
                >
                  About
                </Link>
              </div>
              <div className="nav-item">
                <Link
                  to="/contact"
                  className={
                    location.pathname === "/contact"
                      ? "nav-link active"
                      : "nav-link"
                  }
                >
                  Contact
                </Link>
              </div>
            </div>
          </div>
          <div
            className="col-12 col-sm-6 col-lg-4 order-3 order-sm-2 order-lg-3"
            style={{ marginBottom: "20px" }}
          >
            <div className="messenger">
              <p>Follow us on</p>
              <div>
                <a
                  href="https://instagram.com/BozarovUlugbek"
                  className="nav-link"
                  title="@BozarovUlugbek"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a
                  href="https://web.telegram.org/#/im?p=@BozarovUlugbek"
                  className="nav-link"
                  title="@BozarovUlugbek"
                >
                  <i className="fab fa-telegram-plane"></i>
                </a>
                <a
                  href="https://facebook.com/BozarovUlugbek"
                  className="nav-link"
                  title="@BozarovUlugbek"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer_bottom">
        <div
          className="container"
          style={{
            marginRight: "auto",
            marginLeft: "auto",
            position: "relative",
          }}
        >
          <p className="text-white m-0">© Updating...</p>
          {footerBg()}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
